<template>
  <div class="for-auto">
    <SectionComponent>
      <WrapperComponent title="Все для вашего авто">
        <div class="for-auto_body">
          <CarCard v-for="(item, i) in data" :key="i" :data="item" />
        </div>
      </WrapperComponent>
    </SectionComponent>
  </div>
</template>

<script>
import SectionComponent from "components/SectionComponent.vue";
import WrapperComponent from "components/WrapperComponent.vue";
import CarCard from "components/CarCard.vue";
export default {
  name: "ForAutoBlock",
  props: {
    data: {
      type: Array,
    },
  },
  components: { CarCard, WrapperComponent, SectionComponent },
};
</script>

<style lang="stylus">
.for-auto {
  padding 107px 0
  background var(--light-blue)

  +below(1024px) {
    padding 50px 0
  }

  &_body {
    display grid
    grid-template-columns repeat(5, 1fr)
    gap 30px

    +below(1024px) {
      grid-template-columns repeat(2, 1fr)
    }
  }
}
</style>
